export const flattenTree = <T>(data: T[], childrenSelector: (parent: T) => T[] | null | undefined) => {
  return data.flatMap(function flatten(item): T[] {
    const children = childrenSelector(item);
    if (children) {
      return [item, ...children.flatMap(flatten)];
    }
    return [item];
  });
};
